import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.SaveAndApprovePopupContent', {
    title: 'Save and approve the request',
    submitButton: 'Save and approve',
    description: 'Approvers now have to approve again because of the changes made.',
    commentNote: 'Please provide a comment (optional) to let the Approvers and the Requester know what happened.',
});
